

























import { Component, Prop, Vue } from "vue-property-decorator";
import { ListItem } from "@/store/modules/delayCodes/utils";
import store from "@/store";
import { MutationsTypes } from "../../store/modules/delayCodes/mutations";
import { ListToBeDisplayed } from "../../store/modules/delayCodes/utils";

@Component
export default class GuidedListItem extends Vue {
  @Prop(Object) readonly item!: ListItem;
  @Prop(Boolean) readonly isSelected!: boolean;
  @Prop(Number) readonly listType!: number;

  select = () => {
    switch (this.listType) {
      case ListToBeDisplayed.Process: {
        store.commit.delayCodes[MutationsTypes.SET_PROCESS_ID](
          this.isSelected ? null : this.item.id
        );
        break;
      }
      case ListToBeDisplayed.Reason: {
        store.commit.delayCodes[MutationsTypes.SET_REASON_ID](
          this.isSelected ? null : this.item.id
        );
        break;
      }
      case ListToBeDisplayed.Stakeholder: {
        if (this.item.parentOf.length > 0) {
          store.commit.delayCodes[MutationsTypes.TOGGLE_OPEN_GROUP](
            this.item.id
          );
        } else {
          store.commit.delayCodes[MutationsTypes.SET_STAKEHOLDER_ID](
            this.isSelected ? null : this.item.id
          );
        }
        break;
      }
      default: {
        break;
      }
    }
  };
}
